export default __webpack_public_path__ + "static/img3-df93cf2a42cd3d83492816bc07eb1dbc.png";